import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ujmsCertLog } from "../../services/ujmsApi";
import { Panel, thCls, tdCls, fmtDT, inputCls } from "../ui";

export default function CertifiedLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { ujmsCertLog().then((r) => setRows(r.data)).catch(() => {}); }, []);
  const filtered = rows.filter((r) => !q.trim()
    || `${r.cert_no} ${r.case_number} ${r.order_title} ${r.certified_by}`.toLowerCase().includes(q.trim().toLowerCase()));
  return (
    <div className="space-y-5" data-testid="certlog-page">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Certified Copy Log</h1>
        <p className="text-sm text-slate-500">Register of every certified copy issued by the Clerk's office — certification number, order, case, requester and date.</p>
      </div>
      <input className={`${inputCls} max-w-sm`} placeholder="Search number, case, order or clerk…" value={q}
        onChange={(e) => setQ(e.target.value)} data-testid="certlog-search" />
      <Panel title={`Certifications issued (${filtered.length})`} testId="certlog-panel">
        <table className="w-full border-collapse">
          <thead><tr><th className={thCls}>Certification #</th><th className={thCls}>Order</th><th className={thCls}>Case</th><th className={thCls}>Issued By</th><th className={thCls}>Issued</th></tr></thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id} className="hover:bg-slate-50" data-testid={`certlog-row-${r.cert_no}`}>
                <td className={`${tdCls} font-mono text-xs font-bold text-ujms`}>{r.cert_no}</td>
                <td className={tdCls}>{r.order_title}</td>
                <td className={`${tdCls} font-mono text-xs`}><Link className="text-blue-900 hover:underline" to={`/ujms/cases/${r.case_id}`}>{r.case_number}</Link>
                  <div className="text-slate-400 truncate max-w-[220px]">{r.caption}</div></td>
                <td className={`${tdCls} text-xs`}>{r.certified_by}</td>
                <td className={`${tdCls} font-mono text-xs`}>{fmtDT(r.created_at)}</td>
              </tr>
            ))}
            {!filtered.length && <tr><td colSpan={5} className={tdCls} data-testid="certlog-empty">No certified copies issued yet.</td></tr>}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
